import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import { LangProvider } from './i18n/LangContext';
const Privacy = lazy(() => import('./components/Privacy'));

function App() {
	return (
		<LangProvider>
			<BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
				<div className="font-sans text-slate-900 antialiased">
					<Header />
					<main>
						<Suspense fallback={<div className="py-24 text-center text-slate-500">Loading…</div>}>
							<Routes>
								<Route path="/" element={<>
									<Hero />
									<Services />
									<ContactForm />
								</>} />
								<Route path="/privacy" element={<Privacy />} />
							</Routes>
						</Suspense>
					</main>
					<Footer />
				</div>
			</BrowserRouter>
		</LangProvider>
	);
}

export default App;
